<template>
     <section class="pt-0">
        <div class="container-fluid">
            <div class="row food-section">
                <!-- <div class="col-xl-7 p-0 col-lg-6">
                    <Map></Map>
                </div>               -->
                <div class="col-xl-12 p-0 col-lg-12">
                    <OrderDetail></OrderDetail>
                </div>
            </div>
        </div>
   </section>
</template>

<script>
//import Map from './Order/Map'
import OrderDetail from './Order/OrderDetail'
export default {
    components:{
       // Map,
        OrderDetail
    }
}
</script>

<style>
.food-section{
    height: calc(100vh - 132px);
}
</style>